(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.getElementById('nv-root');
    if (!root) return;

    /* ==========================================================
       Desktop mega menu — hover-intent + keyboard + outside-click
       ========================================================== */
    var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-nv-item][data-has-mega]'));
    var openTimer = null;
    var closeTimer = null;

    function closeAllMega(exceptEl) {
      navItems.forEach(function (item) {
        if (item === exceptEl) return;
        item.classList.remove('is-open');
        var link = item.querySelector('.nv-navlink');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    function openMega(item) {
      clearTimeout(closeTimer);
      closeAllMega(item);
      item.classList.add('is-open');
      var link = item.querySelector('.nv-navlink');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function closeMega(item) {
      item.classList.remove('is-open');
      var link = item.querySelector('.nv-navlink');
      if (link) link.setAttribute('aria-expanded', 'false');
    }

    navItems.forEach(function (item) {
      var link = item.querySelector('.nv-navlink');

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = window.setTimeout(function () {
          openMega(item);
        }, 60);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = window.setTimeout(function () {
          closeMega(item);
        }, 120);
      });

      if (link) {
        link.addEventListener('focus', function () {
          openMega(item);
        });
      }

      item.addEventListener('focusout', function (e) {
        if (item.contains(e.relatedTarget)) return;
        closeMega(item);
      });
    });

    document.addEventListener('click', function (e) {
      var openItem = root.querySelector('.nv-navitem.is-open');
      if (!openItem) return;
      if (!openItem.contains(e.target)) {
        closeMega(openItem);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var openItem = root.querySelector('.nv-navitem.is-open');
      if (openItem) {
        closeMega(openItem);
        var link = openItem.querySelector('.nv-navlink');
        if (link) link.focus();
      }
    });

    /* ==========================================================
       Mobile drawer — open/close, drill-down, scroll lock, focus
       ========================================================== */
    var hamburger = root.querySelector('[data-nv-mob-open]');
    var closeBtn = root.querySelector('[data-nv-mob-close]');
    var drawer = document.getElementById('mob-drawer');
    var overlay = document.getElementById('mob-overlay');
    var panelsContainer = root.querySelector('[data-nv-mob-panels]');
    var lastFocusedBeforeOpen = null;

    function lockBodyScroll() {
      var scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.dataset.nvScrollY = String(scrollY);
    }

    function unlockBodyScroll() {
      var scrollY = parseInt(document.body.dataset.nvScrollY || '0', 10);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      delete document.body.dataset.nvScrollY;
      window.scrollTo(0, scrollY);
    }

    function getFocusable(container) {
      if (!container) return [];
      return Array.prototype.slice.call(
        container.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function openDrawer() {
      if (!drawer) return;
      lastFocusedBeforeOpen = document.activeElement;
      drawer.hidden = false;
      overlay.hidden = false;
      lockBodyScroll();
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
      });
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      var focusable = getFocusable(drawer);
      if (focusable.length) focusable[0].focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      window.setTimeout(function () {
        drawer.hidden = true;
        overlay.hidden = true;
      }, 260);
      unlockBodyScroll();
      if (hamburger) {
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.focus();
      } else if (lastFocusedBeforeOpen) {
        lastFocusedBeforeOpen.focus();
      }
      // reset to root panel
      if (panelsContainer) {
        var panels = panelsContainer.querySelectorAll('[data-nv-panel]');
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        var rootPanel = panelsContainer.querySelector('[data-nv-panel="0"]');
        if (rootPanel) rootPanel.classList.add('is-active');
        panelsContainer.style.transform = 'translateX(0)';
      }
    }

    if (hamburger) hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Drill-down navigation
    if (panelsContainer) {
      panelsContainer.addEventListener('click', function (e) {
        var drillBtn = e.target.closest('[data-nv-drill]');
        if (drillBtn) {
          var idx = drillBtn.getAttribute('data-nv-drill');
          var target = panelsContainer.querySelector('[data-nv-panel="1-' + idx + '"]');
          if (target) {
            drillBtn.setAttribute('aria-expanded', 'true');
            var rootPanel = panelsContainer.querySelector('[data-nv-panel="0"]');
            if (rootPanel) rootPanel.classList.remove('is-active');
            target.classList.add('is-active');
            var focusable = getFocusable(target);
            if (focusable.length) focusable[0].focus();
          }
          return;
        }

        var backBtn = e.target.closest('[data-nv-back]');
        if (backBtn) {
          var currentPanel = backBtn.closest('[data-nv-panel]');
          if (currentPanel) currentPanel.classList.remove('is-active');
          var root0 = panelsContainer.querySelector('[data-nv-panel="0"]');
          if (root0) {
            root0.classList.add('is-active');
            var backTargetBtn = root0.querySelector('[data-nv-drill]');
            if (backTargetBtn) backTargetBtn.focus();
          }
        }
      });
    }

    // Escape closes drawer (mobile drawer takes priority over mega menu, checked first above)
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (drawer && !drawer.hidden) {
        closeDrawer();
      }
    });

    // Focus trap while drawer open
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer || drawer.hidden) return;
      var activePanel = drawer.querySelector('[data-nv-panel].is-active') || drawer;
      var focusable = getFocusable(drawer.querySelector('.nv-mob-drawer__header')).concat(getFocusable(activePanel));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* Search popup open/close is handled natively by the <m-search-popup>
       custom element (registered in header.min.js) via data-open-search-popup
       on the wrapping element — no extra JS needed here. */
  });
})();
